import React from 'react';
import BenchmarkBarChart from './children/BenchmarkBarChart';
import BenchmarkPieChart from './children/BenchmarkPieChart';
import BenchmarkHeatmap from './children/BenchmarkHeatmap';
import KeyTakeAways from './children/KeyTakeAways';
import RatersResponseTable from './children/RatersResponseTable';

const ChartWrapper = () => {
  const tableRows = [
        { key: 'self', label: 'Self', value: 1281 },
        { key: 'directManager', label: 'Direct Manager', value: 1300 },
        { key: 'peer', label: 'Peer', value: 5731 },
        { key: 'directReport', label: 'Direct Report', value: 6671 },
        { key: 'total', label: 'Total Feedback Providers', value: 14983 },
    ];


    return (
        <>
         <RatersResponseTable />
            <BenchmarkBarChart />
            <BenchmarkPieChart />
            <KeyTakeAways />
            <BenchmarkHeatmap />
        </>
    );
};

export default ChartWrapper;